import axios from "axios";
import { submitDemoURL } from '../_constants/api.constant'
import {  getSelfToken } from '../../_helpers/auth/secureToken'
export async function getDemoGenre() {
    const response = await axios.get(
        submitDemoURL.GET_GENRE,
        {
            headers: {
                Authorization: 'Token ' + getSelfToken(),
            },
        }
    ).then(function (response) {
        return response;
    }).catch(function (error) {
        // handle error
        console.log(error);
        console.log(error.response);
        return error.response;
    });
    return response;
}